import { render, staticRenderFns } from "./vergoeding.vue?vue&type=template&id=569db760&scoped=true&"
import script from "./vergoeding.vue?vue&type=script&lang=ts&"
export * from "./vergoeding.vue?vue&type=script&lang=ts&"
import style0 from "./vergoeding.vue?vue&type=style&index=0&id=569db760&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569db760",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VContainer,VImg,VRow,VSimpleTable})
